



































































































































































































































































import { log } from '@/log'
import store from '@/store'
import { columnNameToIndexMap, formatRow, isMultipleSelectionAllowedColumnName } from '@/store/modules/searchContactLens/functions'
import {
  AssetsResolver,
  assetsResolver,
} from '@ajax/vue/components/templates/item-list/condition/contactlens/view/assets'
import { uniq } from 'lodash'
import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { Prop } from 'vue-property-decorator'

@Mixin
export default class SearchSysCondCommon extends Vue {
  @Prop()
  title: string

  @Prop({ default: '/' })
  topUrl: string

  get lensCsvData() {

    return store.state.searchContactLens.csvData
  }

  get assetsResolver(): AssetsResolver {
    return assetsResolver
  }

  get uniqueBCValues() {
    const bcValueIndex = columnNameToIndexMap['bc'!]

    return this.getUniqueValues(bcValueIndex)
  }

  get uniqueDIAValues() {
    const diaValueIndex = columnNameToIndexMap['dia'!]

    return this.getUniqueValues(diaValueIndex)
  }

  get uniqueColoringDiaValues() {
    const coloringDiaValueIndex = columnNameToIndexMap['coloringdia'!]

    return this.getUniqueValues(coloringDiaValueIndex)
  }

  getUniqueValues(valueIndex: number) {
    const csvData: string[][] = []
    const data = this.lensCsvData || []

    /**
     * Removed spaces before and after the CSV value.
     * Otherwise it will be judged as a different value and duplicate conditions will be displayed on the UI.
     * Since contact_lens.csv is manually created in a spreadsheet, so space characters can be introduced.
     * And since there is no intervening system to remove them, they must be removed in Front.
     * @see https://github.com/my-color/front/issues/7306
     */
    data.forEach((row) => {
      csvData.push(formatRow(row))
    })

    const values = csvData.map(row => row[valueIndex])

    return uniq(
      values.filter(v => v !== '非公開')
    ).sort()
  }

  optionClickHandler(
    category: string,
    value: string,
    eventTarget: HTMLElement
  ) {
    const key = columnNameToIndexMap[category]
    if (!key) {
      log.warn(`key for category '${category}' is not found.`)

      return
    }

    const isSameButton = eventTarget.className.includes('search_sys_body_menu_sec_menu_selected')
    if (isSameButton) {
      eventTarget.className = eventTarget.className.replace(' search_sys_body_menu_sec_menu_selected', '')
      this.removeCond(key, value)
    } else {
      if (!isMultipleSelectionAllowedColumnName(category)) {
        const parent = eventTarget.parentElement as Element
        Array.from(parent.children).forEach((element) => {
          element.className = element.className.replace(' search_sys_body_menu_sec_menu_selected', '')
        })
      }
      eventTarget.className += ' search_sys_body_menu_sec_menu_selected'
      this.addCond(key, value)
    }
  }

  mounted() {
    const id = this.$el.id

		// さらに詳細を検索するボタンを押した時の処理
    $(`#${id} .search_sys_body_menu_sec_detail_button`).on('click', function () {
      $(this).next().slideToggle()
      $(this).toggleClass('active')

      if ($(this).hasClass('active')) {
        $(`#${id} .search_sys_body_menu_sec_detail_button img`)
          .attr('src', assetsResolver.root('minus.png'))
      } else {
        $(`#${id} .search_sys_body_menu_sec_detail_button img`)
          .attr('src', assetsResolver.root('plus.png'))
      }
    })

    // 静的な条件に対するハンドラ
    const buildClickHandler = (category: string) =>
      (event: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => {
        // カラーのようにliの中にさらに子要素がある場合、子要素のクリックイベントとなりうる
        // 親方向に探索し、最初にidの付与された要素が見つかったらそれをクリックのイベントと判定する
        const searchTarget = (element: HTMLElement) => {
          if (element.id) {
            return element
          }

          return searchTarget(element.parentElement!)
        }
        const target = searchTarget(event.target)
        this.optionClickHandler(category, target.id, target)
      }
    // デスクトップ/モバイル表示で同じIDを使っているためクリックイベントが2重に発火している可能性がある
    // 回避策として.off('click')を使用している
    $('#period li').off('click').on('click', buildClickHandler('period'))
    $('#color li').off('click').on('click', buildClickHandler('color'))
    $('#corrective li').off('click').on('click', buildClickHandler('corrective'))
    $('#liquidRate li').off('click').on('click', buildClickHandler('liquidRate'))
    $('#border li').off('click').on('click', buildClickHandler('border'))
    $('#hardness li').off('click').on('click', buildClickHandler('hardness'))
    $('#option li').off('click').on('click', buildClickHandler('option'))
  }

  addCond(key: number, value: string) {
    this.$emit('addCond', key, value)
  }

  removeCond(key: number, value: string) {
    this.$emit('removeCond', key, value)
  }
}
